// APEDARegistration.jsx
import React from "react";

export default function APEDARegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            APEDA Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            APEDA Registration for Agri & Food Exports
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports exporters with APEDA Registration for
            agricultural and processed food exports including fruits, vegetables,
            meat products, cereals, and value-added items.
          </p>
          <p className="text-gray-700">
            From IEC integration and product category selection to RCMC issuance
            through APEDA portal and export documentation readiness, the process
            enables international market access with full regulatory compliance.
          </p>
        </div>

        {/* Right: Image (APEDA PERFECT MATCH - Fresh fruits vegetables agricultural export produce) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1099680/pexels-photo-1099680.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Fresh agricultural produce ready for APEDA certified export - fruits vegetables"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for APEDA Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps exporters compile essential trade and
              business documentation for seamless APEDA RCMC registration.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>IEC certificate (Import Export Code) from DGFT.</li>
                <li>PAN card of proprietor, partnership firm, or company directors.</li>
                <li>
                  Business registration proof (GST registration, incorporation
                  certificate, partnership deed, or proprietorship declaration).
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized APEDA support with comprehensive
              export compliance expertise for agricultural products.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Export Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Deep knowledge of APEDA scheduled products, RCMC categories,
                  export licensing requirements, and international quality
                  standards for agri and processed foods.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise IEC-APEDA integration, product category selection,
                  portal registration, and RCMC application preparation with
                  complete documentation packages.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end export readiness from APEDA registration through
                  RCMC issuance, export documentation templates, quality
                  certification guidance, and international compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
